import { render, staticRenderFns } from "./NetError.vue?vue&type=template&id=0f620704&"
import script from "./NetError.vue?vue&type=script&lang=js&"
export * from "./NetError.vue?vue&type=script&lang=js&"
import style0 from "./NetError.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports